import './styles/endpoint-details.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import DetailsSection from '../components/DetailsSection'
import DetailsHeader  from '../components/DetailsHeader'
import Loading        from '../components/Loading'
import GenericConfigDetails from '../components/GenericConfigDetails'

import api from '../redux/api'

export default class EndpointDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
  }

  componentDidMount() {
    const { id } = this.props.match.params

    api.loadEndpoint({ id }).then((result) => {
      this.setState({ loading: false, data: result })
    })
  }

  render() {
    const { loading, data } = this.state

    if (loading) return <Loading />

    return (
      <div className="endpoint-details">
        <div className="header">
          <DetailsHeader title={data.name} type="Endpoint" />
        </div>

        <DetailsSection title="Type" name={data.type} />

        {data.config && <GenericConfigDetails title={`${data.type} Endpoint Config`} config={data.config} />}
      </div>
    )
  }
}
